import { useState } from 'react';
import useInterval from './useInterval';

/**
 * useRetryUntilResolved.
 * helper fn to check for third party depedencies
 * mainly for things attached to window like pixels
 *
 * @param {Function} callback
 * @param {Number} interval
 */
const useRetryUntilResolved = (callback, interval = 100) => {
	const [hasResolved, setHasResolved] = useState(false);
	useInterval(
		() => {
			const result = callback();
			if (result) {
				setHasResolved(true);
			}
		},
		hasResolved ? null : interval
	);
	return hasResolved;
};

export default useRetryUntilResolved;
